import { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import CurvedContainer from "../../components/CurvedContainer";
import Heading2 from "components/Heading/Heading2";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const options = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts`,
};

function PagePDF() {
  const [numPages, setNumPages] = useState<number>();
  const [windowWidth, setWindowWidth] = useState<number>(typeof window !== "undefined" ? window.innerWidth : 1200);

  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }

    handleResize(); // initial load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  return (
    <CurvedContainer>
      {/* Section Titre avec Flexbox pour centrage */}
      <div className="w-full flex justify-center mb-6">
        <Heading2 style={{ color: "black" }} className="text-4xl font-semibold md:text-5xl">
          Curriculum Vitae
        </Heading2>
      </div>

      {/* PDF en pleine largeur */}
      <div className="w-full overflow-x-hidden">
        <Document
          options={options}
          file={"images/CV-GermainBataille.pdf"}
          onLoadSuccess={onDocumentLoadSuccess}
        >
          {Array.from(new Array(numPages), (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={windowWidth * 0.9} // Ajuster la largeur pour qu'il soit plus fluide
              className="mx-auto"
            />
          ))}
        </Document>
      </div>
    </CurvedContainer>
  );
}

export default PagePDF;
